import svgPaths from './svg-k0toq3gn3f';

export default function SvgLogo() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 384 378"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d={svgPaths.p310fe900}
        fill="var(--fill-0, currentColor)"
      />
    </svg>
  );
}
